document.addEventListener("DOMContentLoaded", function () {
  function bindSwatchEventListeners() {
    const swatches = document.querySelectorAll(".swatch");

    swatches.forEach((swatch) => {
      swatch.addEventListener("click", function () {
        const productHandle = this.dataset.product;
        // console.log("Swatch clicked for product:", productHandle);

        // Call your renderSections function or other logic here
        renderSections(productHandle);

        // Update the browser history state
        updateHistoryState(productHandle);
      });
    });
  }

  bindSwatchEventListeners();

  function renderSections(handle) {
    // Assuming you have the sectionId logic in place
    const sectionId =
      document.querySelector(".m-main-product")?.dataset.sectionId;

    fetch(`/products/${handle}?section_id=${sectionId}`)
      .then((response) => response.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");

        // console.log(doc);
        const elementToReplace = document.querySelector(".m-main-product");

        if (elementToReplace) {
          const newContent = doc.querySelector(".m-main-product");
          elementToReplace.innerHTML = newContent ? newContent.innerHTML : "";
        }

        // Add any additional initialization or event dispatching here
        // document.dispatchEvent(new CustomEvent("size-chart:init"));
        // document.dispatchEvent(new CustomEvent("size-chart-parameters:init"));
        // document.dispatchEvent(new CustomEvent("clipboardEvent"));

        // bootstrapSizeNFitComWidgetAuto();
        // document.dispatchEvent(new CustomEvent("observe-size-n-fit:init"));

        // if (document.querySelector("[js-product-modal]")) {
        //   const productModal = doc.querySelector("[js-product-modal]");
        //   document.querySelector("[js-product-modal]").innerHTML = productModal
        //     ? productModal.innerHTML
        //     : "";
        // }

        // document.dispatchEvent(new CustomEvent("product-recommendations:init"));

        // Rebind event listeners after the content is replaced

        createScripts();
        bindSwatchEventListeners();
      })
      .catch((error) =>
        console.error("Error fetching product section:", error)
      );
  }

  function createScripts() {
    var script = document.createElement("script");
    script.src =
      "//www.privadoindia.com/cdn/shopifycloud/shopify/assets/storefront/features-1c0b396bd4d054b94abae1eb6a1bd6ba47beb35525c57a217c77a862ff06d83f.js";
    script.integrity = "sha256-HAs5a9TQVLlKuuHrahvWuke+s1UlxXohfHeoYv8G2D8=";
    script.setAttribute("data-source-attribution", "shopify.dynamic-checkout");
    script.defer = true;
    script.crossOrigin = "anonymous";

    // Append the script element to the document body
    document.body.appendChild(script);
  }

  function updateHistoryState(handle) {
    const newUrl = `${window.location.protocol}//${window.location.host}/products/${handle}`;
    window.history.pushState({ path: newUrl }, "", newUrl);
  }

  window.addEventListener("popstate", function (event) {
    const state = event.state;
    if (state && state.path) {
      const handle = state.path.split("/").pop();
      renderSections(handle);
    } else {
      const path = window.location.pathname;
      const handle = path.split("/").pop();
      if (handle) {
        renderSections(handle);
      } else {
        console.log("handle not found");
      }

      // console.log('not working');
    }
  });

  // console.log("codes working fine");
});
